import { TableRow as NovaBaseTableRow, TableRowProps as NovaTableRowProps } from '@fme-nova/components'
import { default as MuiTableRowBase, TableRowProps as MuiTableRowProps } from '@mui/material/TableRow'

import { createComponentWrapperWithRef, styled, uiTokens } from '../../theme'
import { COLORS } from '../../theme/colors'

type TableRowCursorProp = { cursor?: 'pointer' | 'default' }
type AdditionalProps = { isEmbedded?: boolean; hideDivider?: boolean }

type MuiTableRowCustomProps = MuiTableRowProps & TableRowCursorProp & AdditionalProps
type NovaTableRowCustomProps = NovaTableRowProps & TableRowCursorProp & AdditionalProps

const config = {
  shouldForwardProp: (prop: string) => prop !== 'cursor' && prop !== 'isEmbedded',
}

const MuiTableRow = styled(MuiTableRowBase, config)<MuiTableRowCustomProps>`
  &:hover {
    background-color: ${COLORS.action.hover};
    cursor: ${({ cursor }) => cursor ?? 'pointer'};
  }

  &.Mui-selected {
    background-color: ${COLORS.primary.selected};
  }
`

const NovaTableRow = styled(NovaBaseTableRow, config)<NovaTableRowCustomProps>`
  ${({ hideDivider }) => !hideDivider && `border-bottom: 0.5px solid ${uiTokens.uiStroke.neutral};`}
  ${({ isEmbedded }) => isEmbedded && '&:last-of-type { border-bottom: none; }'}

  &:hover {
    cursor: ${({ cursor }) => cursor ?? 'pointer'};
  }
  &:has(.action-row:hover) {
    background-color: transparent;
  }
`

export const TableRow = createComponentWrapperWithRef<MuiTableRowCustomProps | NovaTableRowCustomProps>(
  {
    mui: MuiTableRow,
    nova: NovaTableRow,
  },
  'TableRow',
)
